import {Component, EventEmitter, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {LoadingService} from "../../services/LoadingService";
import {SwitchBoard} from "../../services/SwitchBoard";
import {takeUntil} from "rxjs/operators";
import {LoginService} from "../../services/Login.service";
import {Session} from "../../services/Session";

declare var jQuery: any;
declare var _: any;

@Component({
  selector: 'app-customer-header',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './customer-header.component.html',
  styleUrl: './customer-header.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CustomerHeaderComponent implements  OnInit, OnDestroy {
  isSideMenuExpanded = false;
  user: any;
  showReconnecting: boolean;
  destroy$: EventEmitter<void> = new EventEmitter<void>();

  constructor(private switchBoard: SwitchBoard,
              private loadingService: LoadingService, private loginService: LoginService) {

    this.user = Session.getUser();
    this.switchBoard.onRefresh.pipe(takeUntil(this.destroy$)).subscribe(reload => {
      this.refreshToken();
    });
    this.switchBoard.onReconnect.pipe(takeUntil(this.destroy$)).subscribe(disconnected => {
      this.showReconnecting = disconnected;
    });
    this.switchBoard.onSideBarExpand.pipe(takeUntil(this.destroy$)).subscribe(flag => {
      this.isSideMenuExpanded = flag;
    });
  }

  logout() {
    this.validateLoginAndRedirect();
  }

  ngOnInit() {
    jQuery(document).ready(function() {
      jQuery(document).foundation();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  refreshToken(){
    this.loadingService.triggerLoadingEvent(true);
    const tokenData = {
      token: Session.getToken(),
      refreshToken: Session.getRefreshToken()
    };
    this.loginService.refreshToken(tokenData).subscribe(data  => {this.updateToken(data); }, error => {
      this.switchBoard.onLogOut.next({});
    });
  }

  updateToken(data){
    const base = this;
    this.loadingService.triggerLoadingEvent(false);
    Session.removeToken();
    Session.setToken(data.token);
    Session.setRefreshToken(data.refreshToken);
    setTimeout(function(){
      base.loadingService.triggerLoadingEvent(false);
    });
  }


  validateLoginAndRedirect(){
    const data = localStorage.getItem('wall_rm');
    const details = JSON.parse(data);
    if (details && details.rememberMe){
      localStorage.clear();
    }else {
      this.switchBoard.onLogOut.next({loggedOut: true});
    }
  }

}
